/**
 * Checkout FE `event_type` values accepted by events-gateway.
 * Mirrored from `@appcharge/frontend-events` leaf DTO `EVENT_TYPE`s (v1.3+) —
 * kept as local string constants so the hot path does not eagerly pull
 * the DTO package into the boot chunk. Unit tests assert drift against
 * the package.
 */
export const FrontendCheckoutEventType = {
  CHECKOUT_LIFECYCLE: 'CHECKOUT_LIFECYCLE',
  ORDER_AWARDING: 'ORDER_AWARDING',
  PAYMENT_INTENT: 'PAYMENT_INTENT',
  CHECKOUT_UI_INTERACTIONS: 'CHECKOUT_UI_INTERACTIONS',
} as const;

export type FrontendCheckoutEventType = (typeof FrontendCheckoutEventType)[keyof typeof FrontendCheckoutEventType];

/**
 * Failure `reason`s we originate ourselves, for conditions where no PSP or BE
 * text exists to forward. Everywhere else `reason` is verbatim provider text.
 *
 * These reach publisher dashboards and get grouped on, so they are fixed
 * English — never translated copy — and must not be reworded casually.
 */
export const FrontendEventReason = {
  UNABLE_TO_LOAD_CHECKOUT: 'Unable to load checkout',
} as const;
